import { intl } from '@fullstory/intl';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { ButtonBase } from '../ButtonBase';
import css from './DragAndDrop.module.scss';

export const dragAndDropHandleClass = 'drag-and-drop-handle';

export interface DragAndDropHandleProps {
  children?: React.ReactNode;
  className?: string;
  style?: Omit<React.CSSProperties, 'cursor'>;
  testId?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  title?: string;
}

export const DragAndDropHandle: React.FC<DragAndDropHandleProps> = ({
  children,
  className,
  style,
  testId = 'drag-and-drop-handle',
  title = intl.formatMessage({ defaultMessage: 'Click to drag', id: '34Mtq2' }),
  onClick,
}) => (
  <ButtonBase
    data-component="DragAndDropHandle"
    style={{
      ...(style ?? {}),
      cursor: 'grab',
    }}
    data-testid={testId}
    className={classNames(dragAndDropHandleClass, css.handle, className)}
    onClick={onClick}
    title={title}
  >
    {children}
  </ButtonBase>
);

DragAndDropHandle.displayName = 'DragAndDropHandle';
